import React, { FunctionComponent } from 'react';

import Waterfall, { WaterfallProps } from '../Waterfall';

import TornadoChartPanel from './TornadoChartPanel';

/**
 * Tornado reports are Waterfall reports with independent (non-stacking) column evaluation. Configuration,
 * metadata (WaterfallChart/WaterfallColumns keys), run trigger, and polling are identical, so the Waterfall
 * component does all of that work; only the result renderer differs.
 */
type TornadoProps = Omit<
  WaterfallProps,
  'ChartPanelComponent' | 'variantLabel' | 'itemNoun'
>;

const Tornado: FunctionComponent<TornadoProps> = (props) => (
  <Waterfall
    {...props}
    ChartPanelComponent={TornadoChartPanel}
    variantLabel="Tornado"
    itemNoun="Bar"
  />
);

export default Tornado;
